<template>
  <v-radio-group
    v-model="selectedGrade"
    hide-details
    row>
    <v-radio
      v-for="(grade, index) in grades"
      :key="index"
      :label="grade.text"
      :value="grade.value"
      :disabled="grade.disabled"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {

  computed: {
    grades() {
      return this.$store.state.master.allGrades
    },
    selectedGrade: {
      get() {
        return this.$store.state.conditions.selectedGrade;
      },
      set(value) {
        this.$store.commit('conditions/setSelectedGrade', {
          grade: value
        })
      }
    }
  },
}
</script>
